import Vue from 'vue';
import Router from 'vue-router';

import login        from '../pages/login';
import forgotpassword        from '../pages/forgotpassword';
import resetpassword        from '../pages/resetpassword';
import dashboard    from '../pages/dashboard';
import settings     from '../pages/settings';
import branch       from '../pages/branch';
import branches     from '../pages/branches';
import users        from '../pages/users';
import profile      from '../pages/profile';
import role         from '../pages/role';
import permission   from '../pages/permission';
import ValidationEmail from '../pages/validation';

Vue.use(Router);

const router=new Router({
    mode:'history',
    routes:[
        {
            path:'/login',
            name:'login',
            component:login,
        },
        {
            path:'/forgot-password',
            name:'forgotpassword',
            component:forgotpassword,
        },
        {
            path:'/reset-password/:token',
            name:'resetpassword',
            component:resetpassword,
        },
        {
            path:'/',
            component:dashboard,
            meta:{
                AuthRequired:true
            }
        },
        {
            path:'/dashboard',
            component:dashboard,
            meta:{
                AuthRequired:true
            }
        },

        // show settings page
        {
            path:'/settings',
            component:settings,
            meta:{
                AuthRequired:true
            }
        },

        // show branches
        {
            path:'/branches',
            component:branches,
            meta:{
                AuthRequired:true
            }
        }, 
        {
            path:'/branch/:id',
            component:branch,
            props: (route) => ({
                id              : route.params.id,
            }),
            meta:{
                AuthRequired:true
            }
        },
        
        
        // Show users
        {
            path:'/users',
            component:users,
            meta:{
                AuthRequired:true
            }
        },

        {
            path:'/users/branch/:branch_id',
            component:users,
            props: (route) => ({
                branch_id              : route.params.branch_id,
            }),
            meta:{
                AuthRequired:true
            }
        },

        // Show profile
        {
            path:'/profile',
            component:profile,
            meta:{
                AuthRequired:true
            }
        },

        // Show profile user
        {
            path:'/profile/:id',
            component:profile,
            props: (route) => ({
                id              : route.params.id,
            }),
            meta:{
                AuthRequired:true
            }
        },

        // edit profile user (also for editing my profile)
        {
            path:'/profile/:id/edit',
            component:profile,
            props: (route) => ({
                id              : route.params.id,
            }),
            meta:{
                AuthRequired:true
            }
        },

        {
            path:'/role/:id',
            component:role,
            props: (route) => ({
                id              : route.params.id,
            }),
            meta:{
                AuthRequired:true
            }
        },

        {
            path:'/permission/:id',
            component:permission,
            props: (route) => ({
                id              : route.params.id,
            }),
            meta:{
                AuthRequired:true
            }
        },
        {
            path:'/validate-email-address/:token',
            component:ValidationEmail, 
        },
        {
            path:'*',
            redirect:'/'
             
        },
        
    ]
});

export default router;


router.beforeEach((to,from,next)=>{
    if(to.matched.some(record => record.meta.AuthRequired)) { 
        if (localStorage.getItem('token') == null) { 
            next({
                path: '/login',
                name:'login' 
            })
            
        } 
        else{
            next(); 
        }
    }
    
    next(); 
})